/**
 * Created by Анжелика on 25.08.2017.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import PropTypes from 'prop-types';
import * as LoginActions from '../actions/login';
import Menu from '../components/Menu';
import Account from '../components/Account';
import ChannelCards from './ChannelCards';

class AppMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            doCollapse: false
        }
    }

    actionDoCollapse() {
        this.setState({doCollapse:true});
    }

    onAccountClick() {
        this.actionDoCollapse();
    }

    render() {
        const {userData: {data: userData}, loginActions, mobileMenuShow, clickMenu} = this.props;
        const {doCollapse} = this.state;
        return (
            <div className={"app-menu " + (mobileMenuShow ? "show" : "")} onClick={clickMenu}>
                <div className="app-menu-wrapper">
                    <Account userName={userData.fname} onClick={this.onAccountClick.bind(this)} />
                    <hr/>
                    <Menu doCollapse={doCollapse} onLogoutClick={loginActions.logout} />
                    <hr/>
                    <ChannelCards onItemClick={this.actionDoCollapse.bind(this)} />
                </div>
            </div>
        )
    }
}

AppMenu.propTypes = {
    userData: PropTypes.object.isRequired,
    loginActions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    return {
        userData: state.users.userData
    }
};

const mapDispatchToProps = dispatch => {
    return {
        loginActions: bindActionCreators(LoginActions, dispatch)
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AppMenu);



// WEBPACK FOOTER //
// ./src/containers/AppMenu.js